import React from "react"
import PropTypes from "prop-types";
import { Col, Alert } from "reactstrap"

const SimpleAlertError = (props) => {

  const { errorAlert, setErrorAlert, text } = props;

  return (
    <React.Fragment>
      <Col id="liveAlertPlaceholder">
        <div id="liveAlertPlaceholder">
          <Alert color="danger" isOpen={errorAlert} toggle={() => {
            setErrorAlert(false)
          }}>
            {text}
          </Alert>
        </div>
      </Col>
    </React.Fragment>
  )
}

SimpleAlertError.propTypes = {
  errorAlert: PropTypes.bool,
  setErrorAlert: PropTypes.func,
  text: PropTypes.string
}

export default SimpleAlertError;
